"use client";

import { useTranslations } from "next-intl";

const NAMESPACE = "new-3d-printing";

const ADVANTAGES = [1, 2, 3, 4, 5, 6] as const;
const APPLICATIONS = [1, 2, 3, 4, 5, 6, 7, 8] as const;

function CheckIcon() {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className="mt-0.5 shrink-0"
			aria-hidden="true"
		>
			<circle cx="10" cy="10" r="10" fill="#83b751" />
			<path
				d="M5.5 10.2 8.5 13l6-6"
				stroke="#ffffff"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</svg>
	);
}

type ColumnProps = {
	title: string;
	intro: string;
	items: readonly number[];
	keyPrefix: "advantagesItem" | "applicationsItem";
};

function Column({ title, intro, items, keyPrefix }: ColumnProps) {
	const t = useTranslations(NAMESPACE);
	return (
		<div className="flex flex-col">
			<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[26px]">{title}</h2>
			<p className="mb-6 text-sm leading-relaxed text-black md:text-base">{intro}</p>
			<ul className="space-y-4 sm:space-y-5">
				{items.map((n) => (
					<li key={n} className="flex items-start gap-3">
						<CheckIcon />
						<p className="text-sm leading-relaxed text-black md:text-base">
							<span className="font-semibold">{t(`${keyPrefix}${n}Name`)}</span>
							<span>：</span>
							{t(`${keyPrefix}${n}Desc`)}
						</p>
					</li>
				))}
			</ul>
		</div>
	);
}

export default function AdvantagesAndApplications() {
	const t = useTranslations(NAMESPACE);
	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid gap-10 md:gap-12 lg:grid-cols-2 lg:gap-16">
					<Column
						title={t("advantagesTitle")}
						intro={t("advantagesIntro")}
						items={ADVANTAGES}
						keyPrefix="advantagesItem"
					/>
					<Column
						title={t("applicationsTitle")}
						intro={t("applicationsIntro")}
						items={APPLICATIONS}
						keyPrefix="applicationsItem"
					/>
				</div>
			</div>
		</section>
	);
}
